var map = {
	"./account_120.png": "a3ae",
	"./account_60.png": "e1c9",
	"./action_list_component_120.png": "24f0",
	"./action_list_component_60.png": "1b40",
	"./actions_and_buttons_120.png": "1040",
	"./actions_and_buttons_60.png": "07a0",
	"./address_120.png": "5b08",
	"./address_60.png": "e732",
	"./agent_session_120.png": "98ce",
	"./agent_session_60.png": "eaab",
	"./all_120.png": "c857",
	"./all_60.png": "b40e",
	"./announcement_120.png": "9b86",
	"./announcement_60.png": "9fea",
	"./answer_best_120.png": "7fea",
	"./answer_best_60.png": "02e2",
	"./answer_private_120.png": "437d",
	"./answer_private_60.png": "0ca0",
	"./answer_public_120.png": "e0f0",
	"./answer_public_60.png": "f47d",
	"./apex_120.png": "0c0b",
	"./apex_60.png": "d336",
	"./apex_plugin_120.png": "5fe9",
	"./apex_plugin_60.png": "bacb",
	"./app_120.png": "7509",
	"./app_60.png": "3bcd",
	"./approval_120.png": "7190",
	"./approval_60.png": "87d8",
	"./apps_120.png": "5b1f",
	"./apps_60.png": "def6",
	"./apps_admin_120.png": "757e",
	"./apps_admin_60.png": "16e4",
	"./article_120.png": "75d7",
	"./article_60.png": "e95f",
	"./asset_relationship_120.png": "182a",
	"./asset_relationship_60.png": "da7f",
	"./assigned_resource_120.png": "274c",
	"./assigned_resource_60.png": "9169",
	"./assignment_120.png": "6a38",
	"./assignment_60.png": "265b",
	"./avatar_120.png": "7dd6",
	"./avatar_60.png": "466b",
	"./avatar_loading_120.png": "f552",
	"./avatar_loading_60.png": "64a9",
	"./bot_120.png": "0d8b",
	"./bot_60.png": "4a94",
	"./bot_training_120.png": "f644",
	"./bot_training_60.png": "9fd4",
	"./branch_merge_120.png": "b221",
	"./branch_merge_60.png": "495a",
	"./brand_120.png": "eb6e",
	"./brand_60.png": "df9e",
	"./business_hours_120.png": "584e",
	"./business_hours_60.png": "50e1",
	"./buyer_account_120.png": "599e",
	"./buyer_account_60.png": "7646",
	"./buyer_group_120.png": "eec3",
	"./buyer_group_60.png": "711d",
	"./calibration_120.png": "7789",
	"./calibration_60.png": "0151",
	"./call_120.png": "7881",
	"./call_60.png": "d70b",
	"./call_history_120.png": "8c78",
	"./call_history_60.png": "5be8",
	"./campaign_120.png": "91b4",
	"./campaign_60.png": "2d97",
	"./campaign_members_120.png": "635c",
	"./campaign_members_60.png": "fd55",
	"./canvas_120.png": "6177",
	"./canvas_60.png": "277f",
	"./carousel_120.png": "87a9",
	"./carousel_60.png": "bbc5",
	"./case_120.png": "d7e6",
	"./case_60.png": "c7a8",
	"./case_change_status_120.png": "91fd",
	"./case_change_status_60.png": "60a8",
	"./case_comment_120.png": "e61b",
	"./case_comment_60.png": "2760",
	"./case_email_120.png": "b17e",
	"./case_email_60.png": "c03d",
	"./case_log_a_call_120.png": "e338",
	"./case_log_a_call_60.png": "defa",
	"./case_milestone_120.png": "be47",
	"./case_milestone_60.png": "a1bb",
	"./case_transcript_120.png": "f59d",
	"./case_transcript_60.png": "4ef1",
	"./catalog_120.png": "3553",
	"./catalog_60.png": "bbc2",
	"./category_120.png": "b919",
	"./category_60.png": "87fc",
	"./channel_program_history_120.png": "704d",
	"./channel_program_history_60.png": "5887",
	"./channel_program_levels_120.png": "c41a",
	"./channel_program_levels_60.png": "b1d8",
	"./channel_program_members_120.png": "60a7",
	"./channel_program_members_60.png": "2914",
	"./channel_programs_120.png": "c210",
	"./channel_programs_60.png": "9d26",
	"./chart_120.png": "b8e7",
	"./chart_60.png": "652f",
	"./choice_120.png": "5149",
	"./choice_60.png": "8130",
	"./client_120.png": "7ade",
	"./client_60.png": "7757",
	"./cms_120.png": "6e2e",
	"./cms_60.png": "074f",
	"./coaching_120.png": "b06f",
	"./coaching_60.png": "82af",
	"./code_playground_120.png": "8b4e",
	"./code_playground_60.png": "f3f7",
	"./collection_variable_120.png": "6b48",
	"./collection_variable_60.png": "e671",
	"./connected_apps_120.png": "dc89",
	"./connected_apps_60.png": "b3aa",
	"./constant_120.png": "1b61",
	"./constant_60.png": "611a",
	"./contact_120.png": "f28a",
	"./contact_60.png": "9a85",
	"./contact_list_120.png": "0319",
	"./contact_list_60.png": "5723",
	"./contact_request_120.png": "8009",
	"./contact_request_60.png": "37c8",
	"./contract_120.png": "030b",
	"./contract_60.png": "fb38",
	"./contract_line_item_120.png": "7f24",
	"./contract_line_item_60.png": "7856",
	"./currency_120.png": "7bf7",
	"./currency_60.png": "64fb",
	"./currency_input_120.png": "0508",
	"./currency_input_60.png": "b13b",
	"./custom_120.png": "be33",
	"./custom_60.png": "2400",
	"./custom_notification_120.png": "5327",
	"./custom_notification_60.png": "fcdc",
	"./customer_360_120.png": "88cf",
	"./customer_360_60.png": "7f81",
	"./customer_portal_users_120.png": "603b",
	"./customer_portal_users_60.png": "b782",
	"./customers_120.png": "f613",
	"./customers_60.png": "7ec3",
	"./dashboard_120.png": "105a",
	"./dashboard_60.png": "50c0",
	"./dashboard_ea_120.png": "d9ca",
	"./dashboard_ea_60.png": "8f52",
	"./data_integration_hub_120.png": "92e3",
	"./data_integration_hub_60.png": "abf0",
	"./datadotcom_120.png": "ba3f",
	"./datadotcom_60.png": "0ed0",
	"./dataset_120.png": "3fcc",
	"./dataset_60.png": "7540",
	"./date_input_120.png": "e244",
	"./date_input_60.png": "c39c",
	"./date_time_120.png": "d291",
	"./date_time_60.png": "9230",
	"./decision_120.png": "fd89",
	"./decision_60.png": "6220c",
	"./default_120.png": "6c3a",
	"./default_60.png": "69c2",
	"./delegated_account_120.png": "506a",
	"./delegated_account_60.png": "395e",
	"./display_rich_text_120.png": "74ca",
	"./display_rich_text_60.png": "a7db",
	"./display_text_120.png": "8be7",
	"./display_text_60.png": "7a02",
	"./document_120.png": "61e3",
	"./document_60.png": "b375",
	"./drafts_120.png": "208e",
	"./drafts_60.png": "184e",
	"./dynamic_record_choice_120.png": "77e8",
	"./dynamic_record_choice_60.png": "6525",
	"./education_120.png": "3c19",
	"./education_60.png": "83aa",
	"./email_120.png": "215f",
	"./email_60.png": "7f6a",
	"./email_chatter_120.png": "a431",
	"./email_chatter_60.png": "a887",
	"./empty_120.png": "d7d7",
	"./empty_60.png": "0574",
	"./endorsement_120.png": "920b",
	"./endorsement_60.png": "9f92",
	"./entitlement_120.png": "ed02",
	"./entitlement_60.png": "124d",
	"./entitlement_policy_120.png": "d0e3",
	"./entitlement_policy_60.png": "3d60",
	"./entitlement_process_120.png": "da20",
	"./entitlement_process_60.png": "776f",
	"./entitlement_template_120.png": "a6dd",
	"./entitlement_template_60.png": "4f89",
	"./entity_120.png": "5d32",
	"./entity_60.png": "3559",
	"./entity_milestone_120.png": "b217",
	"./entity_milestone_60.png": "25f3",
	"./environment_hub_120.png": "696a",
	"./environment_hub_60.png": "0603",
	"./event_120.png": "0f92",
	"./event_60.png": "bd6b",
	"./events_120.png": "25d2",
	"./events_60.png": "bb88",
	"./feed_120.png": "423a",
	"./feed_60.png": "5efb",
	"./feedback_120.png": "4fa1",
	"./feedback_60.png": "c753",
	"./file_120.png": "c7a1",
	"./file_60.png": "5d3c",
	"./filter_120.png": "bb56",
	"./filter_60.png": "4eac",
	"./first_non_empty_120.png": "9597",
	"./first_non_empty_60.png": "a2f9",
	"./flow_120.png": "3b19",
	"./flow_60.png": "8133",
	"./folder_120.png": "ac0a",
	"./folder_60.png": "ee18",
	"./forecasts_120.png": "a68d",
	"./forecasts_60.png": "51e3",
	"./formula_120.png": "2868",
	"./formula_60.png": "7d8a",
	"./fulfillment_order_120.png": "0a04",
	"./fulfillment_order_60.png": "8668",
	"./generic_loading_120.png": "753b",
	"./generic_loading_60.png": "c87a",
	"./global_constant_120.png": "367a",
	"./global_constant_60.png": "41d1",
	"./goals_120.png": "494d",
	"./goals_60.png": "ff5b",
	"./group_loading_120.png": "d3f6",
	"./group_loading_60.png": "7ede",
	"./groups_120.png": "bbed",
	"./groups_60.png": "276d",
	"./hierarchy_120.png": "18d3",
	"./hierarchy_60.png": "a3bf",
	"./high_velocity_sales_120.png": "0be6",
	"./high_velocity_sales_60.png": "8ffa",
	"./home_120.png": "e0bb",
	"./home_60.png": "0f9c",
	"./household_120.png": "07ab",
	"./household_60.png": "0433",
	"./individual_120.png": "dce1",
	"./individual_60.png": "fa42",
	"./insights_120.png": "ebd1",
	"./insights_60.png": "aef1",
	"./instore_locations_120.png": "7f80",
	"./instore_locations_60.png": "f7b0",
	"./investment_account_120.png": "4eec",
	"./investment_account_60.png": "1914",
	"./invocable_action_120.png": "92ea",
	"./invocable_action_60.png": "4c28",
	"./iot_context_120.png": "1973",
	"./iot_context_60.png": "99f4",
	"./iot_orchestrations_120.png": "869b",
	"./iot_orchestrations_60.png": "3ede",
	"./javascript_button_120.png": "e245",
	"./javascript_button_60.png": "f805",
	"./job_profile_120.png": "50f8",
	"./job_profile_60.png": "cb10",
	"./kanban_120.png": "0f8c",
	"./kanban_60.png": "b865",
	"./knowledge_120.png": "4876",
	"./knowledge_60.png": "e1a7",
	"./lead_120.png": "a2e3",
	"./lead_60.png": "191a",
	"./lead_insights_120.png": "58ef",
	"./lead_insights_60.png": "26e4",
	"./lead_list_120.png": "6a2a",
	"./lead_list_60.png": "fcb7",
	"./letterhead_120.png": "1793e",
	"./letterhead_60.png": "e1eb",
	"./lightning_component_120.png": "cbf5",
	"./lightning_component_60.png": "2eca",
	"./lightning_usage_120.png": "f83a",
	"./lightning_usage_60.png": "c526",
	"./link_120.png": "59b4",
	"./link_60.png": "8d0b",
	"./list_email_120.png": "6262",
	"./list_email_60.png": "2fc7",
	"./live_chat_120.png": "a8e6",
	"./live_chat_60.png": "ea07",
	"./live_chat_visitor_120.png": "717f",
	"./live_chat_visitor_60.png": "dc76",
	"./location_120.png": "d557",
	"./location_60.png": "e1f8",
	"./log_a_call_120.png": "7340",
	"./log_a_call_60.png": "d019",
	"./logging_120.png": "5a40",
	"./logging_60.png": "517a",
	"./loop_120.png": "a98d",
	"./loop_60.png": "b137",
	"./macros_120.png": "6e8f",
	"./macros_60.png": "3195",
	"./maintenance_asset_120.png": "83fa",
	"./maintenance_asset_60.png": "59e9",
	"./maintenance_plan_120.png": "80c0",
	"./maintenance_plan_60.png": "ab21",
	"./marketing_actions_120.png": "8e5b",
	"./marketing_actions_60.png": "45f9",
	"./merge_120.png": "829c",
	"./merge_60.png": "3568",
	"./messaging_conversation_120.png": "2a57",
	"./messaging_conversation_60.png": "fe18",
	"./messaging_session_120.png": "cd88",
	"./messaging_session_60.png": "509b",
	"./messaging_user_120.png": "2158",
	"./messaging_user_60.png": "8f9f",
	"./metrics_120.png": "d816",
	"./metrics_60.png": "ac76",
	"./multi_picklist_120.png": "6eee",
	"./multi_picklist_60.png": "39d2",
	"./multi_select_checkbox_120.png": "b779",
	"./multi_select_checkbox_60.png": "b7a7",
	"./news_120.png": "70a7",
	"./news_60.png": "b9c8",
	"./note_120.png": "1291",
	"./note_60.png": "7a29",
	"./number_input_120.png": "2b9b",
	"./number_input_60.png": "ac3e",
	"./omni_supervisor_120.png": "4585",
	"./omni_supervisor_60.png": "f069",
	"./operating_hours_120.png": "2a6c",
	"./operating_hours_60.png": "df1b",
	"./opportunity_120.png": "b5e7",
	"./opportunity_60.png": "2d08",
	"./opportunity_contact_role_120.png": "7343",
	"./opportunity_contact_role_60.png": "e5cd",
	"./opportunity_splits_120.png": "e613",
	"./opportunity_splits_60.png": "6543",
	"./order_item_120.png": "5f18",
	"./order_item_60.png": "8937",
	"./orders_120.png": "9dae",
	"./orders_60.png": "1ec9",
	"./outcome_120.png": "a96f",
	"./outcome_60.png": "8e71",
	"./output_120.png": "dde3",
	"./output_60.png": "3a72",
	"./partner_fund_allocation_120.png": "a543",
	"./partner_fund_allocation_60.png": "d57b",
	"./partner_fund_claim_120.png": "7cf8",
	"./partner_fund_claim_60.png": "282e",
	"./partner_fund_request_120.png": "4db1",
	"./partner_fund_request_60.png": "b2d8",
	"./partner_marketing_budget_120.png": "a992",
	"./partner_marketing_budget_60.png": "1705",
	"./partners_120.png": "9dc4",
	"./partners_60.png": "9a7a",
	"./password_120.png": "f57d",
	"./password_60.png": "3990",
	"./past_chat_120.png": "e1fc",
	"./past_chat_60.png": "d692",
	"./people_120.png": "253c",
	"./people_60.png": "3ff4",
	"./performance_120.png": "c828",
	"./performance_60.png": "f7f1",
	"./person_account_120.png": "46a4",
	"./person_account_60.png": "a2e6",
	"./photo_120.png": "e6ea",
	"./photo_60.png": "9c26",
	"./picklist_choice_120.png": "f446",
	"./picklist_choice_60.png": "7cfb",
	"./picklist_type_120.png": "4b60",
	"./picklist_type_60.png": "e049",
	"./planogram_120.png": "e7b5",
	"./planogram_60.png": "f770",
	"./poll_120.png": "dcd01",
	"./poll_60.png": "e466",
	"./portal_120.png": "f771",
	"./portal_60.png": "93a5",
	"./portal_roles_120.png": "7f58",
	"./portal_roles_60.png": "4477",
	"./portal_roles_and_subordinates_120.png": "1606",
	"./portal_roles_and_subordinates_60.png": "2410",
	"./post_120.png": "be46",
	"./post_60.png": "937f",
	"./pricebook_120.png": "0df3",
	"./pricebook_60.png": "b2a6",
	"./process_120.png": "57dc",
	"./process_60.png": "b33e",
	"./product_120.png": "4f4a",
	"./product_60.png": "6d2e",
	"./product_consumed_120.png": "9988",
	"./product_consumed_60.png": "b801",
	"./product_item_120.png": "0364",
	"./product_item_60.png": "63c8",
	"./product_item_transaction_120.png": "1431",
	"./product_item_transaction_60.png": "5ea5",
	"./product_request_120.png": "b236",
	"./product_request_60.png": "b02e",
	"./product_request_line_item_120.png": "aeea",
	"./product_request_line_item_60.png": "3ae5",
	"./product_required_120.png": "b4fd",
	"./product_required_60.png": "394e",
	"./product_transfer_120.png": "e146",
	"./product_transfer_60.png": "49d4",
	"./proposition_120.png": "3c60",
	"./proposition_60.png": "ee48",
	"./push_120.png": "a400",
	"./push_60.png": "fdab",
	"./question_best_120.png": "ace9",
	"./question_best_60.png": "ba6d",
	"./question_feed_120.png": "4a9e",
	"./question_feed_60.png": "eb3b",
	"./queue_120.png": "b11b",
	"./queue_60.png": "7114",
	"./quick_text_120.png": "11b7",
	"./quick_text_60.png": "478b",
	"./quip_120.png": "9a6c",
	"./quip_60.png": "d706",
	"./quip_sheet_120.png": "82e8",
	"./quip_sheet_60.png": "f1f6",
	"./quotes_120.png": "a044",
	"./quotes_60.png": "71e0",
	"./radio_button_120.png": "7f8e",
	"./radio_button_60.png": "b7e7",
	"./read_receipts_120.png": "fb14",
	"./read_receipts_60.png": "57ad",
	"./recent_120.png": "63de",
	"./recent_60.png": "ed5a",
	"./record_120.png": "a81b",
	"./record_60.png": "fea8",
	"./record_create_120.png": "ee52",
	"./record_create_60.png": "721b",
	"./record_delete_120.png": "b5a2",
	"./record_delete_60.png": "9f5b",
	"./record_lookup_120.png": "7298",
	"./record_lookup_60.png": "f3e5",
	"./record_update_120.png": "ded9",
	"./record_update_60.png": "45a8",
	"./recycle_bin_120.png": "1c7b",
	"./recycle_bin_60.png": "eca4",
	"./related_list_120.png": "9b52",
	"./related_list_60.png": "e067",
	"./relationship_120.png": "bfc8",
	"./relationship_60.png": "f946",
	"./report_120.png": "3de7",
	"./report_60.png": "7ff2",
	"./resource_absence_120.png": "ec62",
	"./resource_absence_60.png": "9493",
	"./resource_capacity_120.png": "7b22",
	"./resource_capacity_60.png": "b9bd",
	"./resource_preference_120.png": "c8a8",
	"./resource_preference_60.png": "c28d",
	"./resource_skill_120.png": "ea13",
	"./resource_skill_60.png": "bd7b",
	"./return_order_120.png": "bf1e",
	"./return_order_60.png": "2b64",
	"./return_order_line_item_120.png": "5c36",
	"./return_order_line_item_60.png": "3e45",
	"./reward_120.png": "a366",
	"./reward_60.png": "409a",
	"./rtc_presence_120.png": "caaa",
	"./rtc_presence_60.png": "9801",
	"./sales_cadence_120.png": "f91c",
	"./sales_cadence_60.png": "6200",
	"./sales_cadence_target_120.png": "b665",
	"./sales_cadence_target_60.png": "6139",
	"./sales_channel_120.png": "0027",
	"./sales_channel_60.png": "574f",
	"./sales_path_120.png": "7814",
	"./sales_path_60.png": "ddb3",
	"./scan_card_120.png": "c304",
	"./scan_card_60.png": "fab8",
	"./screen_120.png": "845c",
	"./screen_60.png": "1985b",
	"./search_120.png": "6e1a",
	"./search_60.png": "366c",
	"./service_appointment_120.png": "7c2b",
	"./service_appointment_60.png": "e5d4",
	"./service_appointment_capacity_usage_120.png": "2886",
	"./service_appointment_capacity_usage_60.png": "215c",
	"./service_contract_120.png": "2ec0",
	"./service_contract_60.png": "896b",
	"./service_crew_120.png": "56da",
	"./service_crew_60.png": "53fa",
	"./service_crew_member_120.png": "82b8",
	"./service_crew_member_60.png": "5d7f",
	"./service_report_120.png": "6b14",
	"./service_report_60.png": "5aeb",
	"./service_resource_120.png": "348b",
	"./service_resource_60.png": "dd96",
	"./service_territory_120.png": "f80f",
	"./service_territory_60.png": "7ab1",
	"./service_territory_location_120.png": "f143",
	"./service_territory_location_60.png": "960d",
	"./service_territory_member_120.png": "472d",
	"./service_territory_member_60.png": "70fbb",
	"./shift_120.png": "c70e",
	"./shift_60.png": "1eb1",
	"./shift_type_120.png": "ff06",
	"./shift_type_60.png": "c1199",
	"./shipment_120.png": "0daa",
	"./shipment_60.png": "53e5",
	"./skill_120.png": "b789",
	"./skill_60.png": "c2ba",
	"./skill_entity_120.png": "7dc3",
	"./skill_entity_60.png": "9ec8",
	"./skill_requirement_120.png": "9102",
	"./skill_requirement_60.png": "0d8c",
	"./sms_120.png": "8757",
	"./sms_60.png": "07a7",
	"./snippet_120.png": "ab04",
	"./snippet_60.png": "5201",
	"./snippets_120.png": "62e9",
	"./snippets_60.png": "65df",
	"./sobject_120.png": "8a8b",
	"./sobject_60.png": "1c1e",
	"./sobject_collection_120.png": "e5b3",
	"./sobject_collection_60.png": "1881",
	"./social_120.png": "45e8",
	"./social_60.png": "4c81",
	"./solution_120.png": "ddb3c",
	"./solution_60.png": "ba50",
	"./sort_120.png": "c3f2",
	"./sort_60.png": "7025",
	"./sossession_120.png": "4d41",
	"./sossession_60.png": "7d87",
	"./stage_120.png": "1d3e",
	"./stage_60.png": "12fe",
	"./stage_collection_120.png": "49de",
	"./stage_collection_60.png": "1543",
	"./steps_120.png": "6d5c",
	"./steps_60.png": "3fde",
	"./store_120.png": "0092",
	"./store_60.png": "0c20",
	"./store_group_120.png": "73e6",
	"./store_group_60.png": "6fce",
	"./story_120.png": "7343b",
	"./story_60.png": "27ba",
	"./strategy_120.png": "fd24",
	"./strategy_60.png": "b5ed",
	"./survey_120.png": "132c",
	"./survey_60.png": "6507",
	"./system_and_global_variable_120.png": "de75",
	"./system_and_global_variable_60.png": "9ed8",
	"./task2_120.png": "f409",
	"./task2_60.png": "8a32",
	"./task_120.png": "3463",
	"./task_60.png": "287f",
	"./team_member_120.png": "caaa2",
	"./team_member_60.png": "739c",
	"./template_120.png": "26e4e",
	"./template_60.png": "1b1b",
	"./text_120.png": "3162",
	"./text_60.png": "ca65",
	"./text_template_120.png": "db16",
	"./text_template_60.png": "5eb2",
	"./textarea_120.png": "81a3",
	"./textarea_60.png": "f0eb",
	"./textbox_120.png": "6e93",
	"./textbox_60.png": "2f85",
	"./thanks_120.png": "5f0e",
	"./thanks_60.png": "651d",
	"./thanks_loading_120.png": "22a4",
	"./thanks_loading_60.png": "395a",
	"./timesheet_120.png": "0766",
	"./timesheet_60.png": "d3d6",
	"./timesheet_entry_120.png": "1e3d",
	"./timesheet_entry_60.png": "36dc",
	"./timeslot_120.png": "b262",
	"./timeslot_60.png": "d4cc",
	"./today_120.png": "4d0e",
	"./today_60.png": "8212",
	"./topic2_120.png": "7cb9",
	"./topic2_60.png": "828e",
	"./topic_120.png": "e8ff1",
	"./topic_60.png": "cc0c",
	"./trailhead_120.png": "34a1",
	"./trailhead_60.png": "3e33",
	"./unmatched_120.png": "9d8f",
	"./unmatched_60.png": "beb8",
	"./user_120.png": "9344",
	"./user_60.png": "fe4f",
	"./user_role_120.png": "d1794",
	"./user_role_60.png": "7378",
	"./variable_120.png": "89e3",
	"./variable_60.png": "2cd1",
	"./visit_templates_120.png": "235f",
	"./visit_templates_60.png": "7e35",
	"./visits_120.png": "52ad",
	"./visits_60.png": "a361",
	"./visualforce_page_120.png": "9a9d",
	"./visualforce_page_60.png": "fc8f",
	"./waits_120.png": "620e",
	"./waits_60.png": "ff48",
	"./work_capacity_limit_120.png": "1af8",
	"./work_capacity_limit_60.png": "6afa",
	"./work_capacity_usage_120.png": "b195",
	"./work_capacity_usage_60.png": "ee4f",
	"./work_order_120.png": "1df4",
	"./work_order_60.png": "fe18d",
	"./work_order_item_120.png": "2fdc",
	"./work_order_item_60.png": "0610",
	"./work_queue_120.png": "2237",
	"./work_queue_60.png": "0e69",
	"./work_type_120.png": "0943",
	"./work_type_60.png": "a792",
	"./work_type_group_120.png": "8832",
	"./work_type_group_60.png": "5d87"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1793";